// export function visualBubbleSort(that){
//
//   array = that.state.array;
//   let len = array.length;
//   let reads = 0;
//   let writes = 0;
//
//   for (let i=0; i<len; i++){
//     for (let j=0; j<len-i-1; j++){
//       animations.push([0,j,j+1,array[j],array[j+1],reads,writes]);
//       reads += 1
//       if (array[j] > array[j+1]){
//         animations.push([1,j,j+1,array[j],array[j+1],reads,writes]);
//         [array[j], array[j+1]] = [array[j+1],array[j]];
//         writes += 1
//         animations.push([1,j,j+1,array[j],array[j+1],reads,writes]);
//         animations.push([0,j,j+1,array[j],array[j+1],reads,writes]);
//       }
//     }
//   }
//   // console.log(array);
//   return animations
// }










export function visualBubbleSort(array){
  let animations = []; //[type, i, j, arr[i], arr[j], reads, writes] 0=read, 1=write
  let len = array.length;
  let reads = 0;
  let writes = 0;

  for (let i=0; i<len; i++){
    for (let j=0; j<len-i-1; j++){
      animations.push([0,j,j+1,array[j],array[j+1],reads,writes]);
      reads += 1
      if (array[j] > array[j+1]){
        animations.push([1,j,j+1,array[j],array[j+1],reads,writes]);
        [array[j], array[j+1]] = [array[j+1],array[j]];
        writes += 1
        animations.push([1,j,j+1,array[j],array[j+1],reads,writes]);
        animations.push([0,j,j+1,array[j],array[j+1],reads,writes]);
      }
    }
  }
  // console.log(array);
  return animations
}
